import React, { useState, useEffect } from "react";
import { RxCross1 } from "react-icons/rx";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Constant from "../Components/Utils/Constant";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import { MdArrowDropDown } from "react-icons/md";

export default function EditModelUser({ user, onClose, setEditData, cuponRes, subscriptionRes }) {
    const [subscription, setSubscription] = useState('');
    const [videos, setVideos] = useState([]);
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(true);
    const [collectedamount, setCollectedamount] = useState(0);
    const [cuponapplied, setCuponapplied] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const updatedUser = {
                email: user.email,
                subscription,
                subscriptionexpiry: false,
                collectedamount: isNaN(grandtotal) ? total : grandtotal,
                cuponapplied,
            };
            await axios.put(
                `${Constant.BASE_URL}/user/updatebyid`,
                updatedUser
            );
            setEditData(updatedUser);
            setEditData(false);
            setCollectedamount('')
            setCuponapplied('')
            toast.success("User Updated successfully");
            handleClose();
            setTimeout(() => {
                handleClose();
            }, 3000);
        } catch (error) {
            console.error("Error updating user:", error);
        }
    };
    const handleClose = () => {
        setIsVisible(false);
        onClose();
    };
    var cupondiscount = cuponRes && cuponRes.cupon.find(item => item.cuponcode === cuponapplied)?.cupondiscount;
    var charges = subscriptionRes.subscription.find(item => item.planevalidity === Number(subscription))?.price;
    var cgst = (9 * charges) / 100;
    var sgst = (9 * charges) / 100;
    var scper = charges + cgst + sgst;
    var sc = (2 * scper) / 100;
    var total = cgst + sgst + sc + charges;
    var cupondiscountprice = (cupondiscount * total) / 100;
    var grandtotal = total - cupondiscountprice;




    return isVisible ? (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="popup-formmodel">
                <div className="bg-white rounded-lg shadow-lg p-6 relative">
                    <div className="flex justify-center items-center mb-4 ">
                        <h2 className="text-lg font-semibold text-center">User Subscription Plan</h2>

                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="flex py-3 justify-end">
                            <label
                                htmlFor="yourSelect"
                                className=" mb-1 flex items-center px-3"
                            >
                                Subscription :
                                <span className="text-red-500 ml-1">*</span>
                            </label>
                            <div className="relative ">
                                <select
                                    id="subscription"
                                    className="border-b border-gray-500 appearance-none outline-none createuserline "
                                    value={subscription}
                                    onChange={(e) => setSubscription(e.target.value)}
                                    required
                                >
                                    <option value="" disabled>
                                        Select
                                    </option>
                                    {subscriptionRes?.subscription?.map((plan, index) => {
                                        if (plan.planevisibility && plan.planevisibility.includes("Affiliate")) {
                                            return (
                                                <option key={index} value={plan?.planevalidity}>

                                                    {`Plan: ${plan?.planname} - Duration: ${plan?.planevalidity} days - Price: ${plan?.price}`}
                                                </option>
                                            );
                                        } else {
                                            return 'No Coupons Found';
                                        }
                                    })}
                                </select>


                                <span className="absolute inset-y-0 right-0 flex items-center pointer-events-none">
                                    <div className="bg-white shadow-md border border-white mb-2">
                                        <MdArrowDropDown className="text-1xl" />
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="flex py-3 justify-end">
                            <label
                                htmlFor="yourSelect"
                                className=" mb-1 flex  px-3 "
                            >
                                Coupon :

                            </label>
                            <div className="relative">
                                <input
                                    id="cuponapplied"
                                    className="border-b border-gray-500 appearance-none outline-none createuserline"
                                    value={cuponapplied}
                                    placeholder="Enter Cupon code"
                                    onChange={(e) => setCuponapplied(e.target.value)}

                                /> <b />
                                <p className="" style={{ color: isNaN(grandtotal) ? 'red' : 'green' }}>
                                    {cuponRes?.cupon?.find(coupon => coupon === cuponapplied) ? (
                                        <p>{cuponRes?.cupon?.cupondiscount}</p>
                                    ) : (
                                        isNaN(grandtotal) ? " " : "Coupon Applied Successfully"
                                    )}
                                </p>

                            </div>



                        </div>
                        <div className="flex py-3 justify-end ">
                            {subscription && (
                                <div className=" text-gray-600 italic">
                                    Subscription Charges: {charges}<br />
                                    CGST (9%): {cgst}<br />
                                    SGST (9%): {sgst}<br />
                                    Service Charges (2%): {sc}<br />
                                    <hr className="fw-bolder" />
                                    Total: {total};<br />
                                    {cuponapplied && (
                                        <div>
                                            Coupon Discount: {cupondiscount || 0}% ;
                                            <hr className="fw-bolder" />
                                            {isNaN(grandtotal) ? (
                                                <p>Total: {total}</p>
                                            ) : (
                                                <p>Grand Total: {grandtotal}</p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="flex justify-center gap-10 text-center mt-10">
                            <button onClick={handleClose} type="" className="inline-flex items-center px-8 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Cancel
                            </button>
                            <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Activate Plan
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        </>
    ) : null;
}